import React from 'react';
import { Box } from '@material-ui/core';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ShipAddressModal from './selectShipToAddress/SelectShipToAddressDesktop';
import { isIpad, logErrorToConsole, getArrayItem } from 'src/utils/util';
import { BackIconContainer } from '../../header/ReportUsageHeader.styled';
import DownArrow from 'src/assets/images/DownArrowFilter.svg';
import { BackIcon } from './selectShipToAddress/ShipAddressModal.styled';
import { useTranslation } from 'react-i18next';
import { clearError } from '../../redux/action/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import AccountOrSurgeonError from '../../../scheduleSurgery/components/surgery/notifications/AccountOrSurgeonError';

const ReplenHeader = ({
    disableSelectShipToAddressBtn,
    disableClearSelectedBtn,
    clearSelectedClickHandler,
    shipAddress,
    setShipAddress,
    onClose,
    gridData,
    setGridData,
    districtsFromIndex,
    territoriesFromIndex,
    disableApplyShipToButton,
    isReportPayment,
    navigateToSpecifiedScreen,
    selectShipToAddressClickHandler = () => {},
    surgeonErrorPopup,
    accountErrorPopup,
    accountError,
    surgeonError,
    popupNotificationsStack,
    setPopupNotificationsStack,
    setAccountErrorPopup = () => {},
    setSurgeonErrorPopup = () => {},
    showShipToAddressPopup,
    applyShippingAddress = () => {},
    ApplyShipToAddress = () => {},
    setSelectedBillToId = () => {},
    selectedBillToId,
    setUsageTransferRecipient = () => {},
    usageTransferRecipient,
    setShippingMethodValue = () => {},
    shippingMethodValue,
    setSelectedShipTo = () => {},
    selectedShipTo,
    setShipToClick = () => {},
    applyClickOutside,
    setApplyClickOutside = () => {},
    shipToClick,
    setCareOfValue = () => {},
    careOfValue,
    setInsideAccountDetails = () => {},
    insideAccountDetails,
    setAttnValue,
    attnValue,
    showReportPayment,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    return (
        <Box style={{ marginTop: isCondensedView && '3%' }} bgcolor={'#F5F5F5'}>
            {isReportPayment ? (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <BackIconContainer isReplenScreen={isReportPayment}>
                        <BackIcon
                            id={`backIcon-${isReportPayment ? 'reportPayment' : 'default'}`}
                            src={DownArrow}
                            alt={'backIcon'}
                            onClick={() =>
                                navigateToSpecifiedScreen('Replen', true)
                            }
                        />
                    </BackIconContainer>

                    <h3
                        style={{
                            fontFamily: 'AvenirNextWorld Demi',
                            color: '#140F4B',
                            fontSize: '20px',
                            letterSpacing: '0px',
                            opacity: '1',
                        }}
                    >
                        {t(
                            'reportUsage.replen.replenHeader.replenishmentRequest'
                        )}
                    </h3>
                </div>
            ) : (
                <h3
                    style={{
                        fontFamily: 'AvenirNextWorld Demi',
                        color: '#140F4B',
                        fontSize: '20px',
                        letterSpacing: '0px',
                        opacity: '1',
                    }}
                >
                    {t('reportUsage.replen.replenHeader.replenishmentRequest')}
                </h3>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <Button
                        id={'reportUsage-replen-replenSelectShipToAddressButton'}
                        show
                        variant = {disableSelectShipToAddressBtn 
                            ? ButtonStyles?.shipToAddressDisabled 
                            : ButtonStyles?.shipToAddressEnabled
                        }
                        width={'180px'}
                        height={'32px'}
                        clicked={() => {
                            try {
                            // if (accountError?.length === 0 || surgeonError?.length === 0)
                            setShipAddress(true);
                            setShipToClick(false);
                            selectShipToAddressClickHandler();
                            } catch (error) {
                              logErrorToConsole(error);
                             }
                        }}
                        margin={'5px 0px 5px 0px'}
                        fontSize={'14px'}
                        disabled={disableSelectShipToAddressBtn}
                    >
                        {t(
                            'reportUsage.replen.replenHeader.selectShipToAddress'
                        )}
                    </Button>
                </div>

                <div>
                    <Button
                    id={'reportUsage-replen-replenClearSelectedButton'}
                        show
                        variant = {disableClearSelectedBtn 
                            ? ButtonStyles?.clearSelectedDisabled 
                            : ButtonStyles?.clearSelectedEnabled
                        }
                        width={
                            window.innerWidth <= 576 || isIpad()
                                ? '117px'
                                : window.innerWidth > 576 &&
                                  window.innerWidth <= 1024 &&
                                  window.innerHeight <= 576
                                ? '125px'
                                : '111px'
                        }
                        height={'34px'}
                        clicked={clearSelectedClickHandler}
                        margin={'5px 0px 5px 5px'}
                        fontSize={'13px'}
                        borderRadius={'6px'}
                        disabled={disableClearSelectedBtn}
                        padding={'0'}
                    >
                        {t(
                            'reportUsage.replen.replenHeader.clearSelectedButton'
                        )}
                    </Button>
                </div>
                {shipAddress && (
                    <ShipAddressModal
                        onClose={onClose}
                        gridData={gridData}
                        setGridData={setGridData}
                        districtsFromIndex={districtsFromIndex}
                        territoriesFromIndex={territoriesFromIndex}
                        disableApplyShipToButton={disableApplyShipToButton}
                        applyShippingAddress={applyShippingAddress}
                        ApplyShipToAddress={ApplyShipToAddress}
                        setSelectedBillToId={setSelectedBillToId}
                        selectedBillToId={selectedBillToId}
                        setUsageTransferRecipient={setUsageTransferRecipient}
                        usageTransferRecipient={usageTransferRecipient}
                        setShippingMethodValue={setShippingMethodValue}
                        shippingMethodValue={shippingMethodValue}
                        setSelectedShipTo={setSelectedShipTo}
                        selectedShipTo={selectedShipTo}
                        setShipToClick={setShipToClick}
                        applyClickOutside={applyClickOutside}
                        setApplyClickOutside={setApplyClickOutside}
                        shipToClick={shipToClick}
                        setCareOfValue={setCareOfValue}
                        careOfValue={careOfValue}
                        setInsideAccountDetails={setInsideAccountDetails}
                        insideAccountDetails={insideAccountDetails}
                        setAttnValue={setAttnValue}
                        attnValue={attnValue}
                        showReportPayment={showReportPayment}
                    />
                )}
                {accountErrorPopup && (
                    <AccountOrSurgeonError
                        onClose={() => {
                            try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setAccountErrorPopup(false);
                            if (popups.length === 0) {
                                // showShipToAddressPopup && setShipAddress(true);
                                dispatch(clearError());
                            }
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        title={t('productValidationMessages.productRestricted')}
                        message={getArrayItem(accountError)?.description}
                        productsNotAddedToCart={getArrayItem(accountError)?.products}
                    />
                )}
                {surgeonErrorPopup && (
                    <AccountOrSurgeonError
                        onClose={() => {
                            try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setSurgeonErrorPopup(false);
                            if (popups.length === 0) {
                                // showShipToAddressPopup && setShipAddress(true);
                                dispatch(clearError());
                            }
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        title={t('productValidationMessages.productRestricted')}
                        message={getArrayItem(surgeonError)?.description}
                        productsNotAddedToCart={getArrayItem(surgeonError)?.products}
                    />
                )}
            </div>
        </Box>
    );
};

export default ReplenHeader;
